import { render, staticRenderFns } from "./InventoryHistory.vue?vue&type=template&id=54e3ab25"
import script from "./InventoryHistory.vue?vue&type=script&lang=js"
export * from "./InventoryHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports